import { useEffect, useState } from "react"
import { Button, Col, Form, Row } from "react-bootstrap"
import { useTranslation } from "react-i18next"
import Select from "react-select"
import provinces from '../../components/provinces.json'
import towns from '../../components/towns.json'

export default function OperatorForm({ state, handleInputChange, submit, isAddingOrEditing, isRegistering, handleDeleteOperators, disableEnableOperators }) {
    const { t } = useTranslation()

    const [provinceAux, setProvinceAux] = useState({label: '', value: ''})
    const [townAux, setTownAux] = useState({label: '', value: ''})
    const [townsAux, setTownsAux] = useState([])

    useEffect(() => {
        if (state) {
            if (state.province) {
                const selectedProvince = provinces.find(province => province.value === state.province);
                if (selectedProvince) {
                    setProvinceAux({ label: selectedProvince.label, value: selectedProvince.value });
                }
            }

            if (state.town) {
                const selectedTown = towns.find(town => town.value === state.town);
                if (selectedTown) {
                    setTownAux({ label: selectedTown.label, value: selectedTown.value });
                }
            }
        }
    }, [state])

    useEffect(() => {
        if(state.province){
            handleInputChange({
                target: {
                    name: 'town',
                    value: ''
                }
            });

            setTownAux({ label: '', value: '' })
            setTownsAux(towns.filter(town => town.parent_value === state.province))
        }
    }, [state.province]);

    const handleSelectProvinceChange = (selected) => {
        handleInputChange({
            target: {
                name: 'province',
                value: selected.value
            }
        })

        setProvinceAux(selected)
    }

    const handleSelectTownChange = (selected) => {
        handleInputChange({
            target: {
                name: 'town',
                value: selected.value
            }
        })
    
        setTownAux(selected);
    }

    return (
        <Form onSubmit={submit} className="px-4 formulario">
            <Row>
                <Col xs={12} md={5} className="my-2">
                    <Form.Label>{t('admin.operators.name')} *</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='name'
                        value={state.name || ''}
                        onChange={handleInputChange}
                        required
                    />
                </Col>
                <Col xs={12} md={7} className="my-2">
                    <Form.Label>{t('admin.operators.lastname')} *</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='lastname'
                        value={state.lastname || ''}
                        onChange={handleInputChange}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4} className="my-2">
                    <Form.Label>{t('admin.operators.phone')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='phone'
                        value={state.phone || ''}
                        onChange={handleInputChange}
                    />
                </Col>
                <Col xs={12} md={8} className="my-2">
                    <Form.Label>{t('admin.operators.email')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='email'
                        name='email'
                        value={state.email || ''}
                        onChange={handleInputChange}
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={12} md={4} className="my-2">
                    <Form.Label>{t('admin.operators.nif')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='nif'
                        value={state.nif || ''}
                        onChange={handleInputChange}
                    />
                </Col>
                <Col xs={12} md={8} className="my-2">
                    <Form.Label>{t('admin.operators.address')}</Form.Label>
                    <Form.Control
                        className="sd-input"
                        type='text'
                        name='address'
                        value={state.address || ''}
                        onChange={handleInputChange}
                    />
                </Col>
            </Row>
            <Row className="mt-3">
                <Col xs={12} md={6}>
                    <Form.Label htmlFor='province'>{t('admin.workOrders.province')}</Form.Label>
                    <Select
                        className="select"
                        classNamePrefix="sd-select"
                        name={'province'}
                        options={provinces.sort((a, b) => {
                                if (a.label < b.label) { return -1 }
                                if (a.label > b.label) { return 1 }
                                return 0
                            })}
                        value={provinceAux || null}
                        onChange={(e) => handleSelectProvinceChange(e)}
                    />
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0 }}
                        value={state.province || ''}
                        readOnly
                    />
                </Col>
                <Col xs={12} md={6}>
                    <Form.Label htmlFor='town'>{t('admin.workOrders.town')}</Form.Label>
                    <Select
                        className="select"
                        classNamePrefix="sd-select"
                        name={'town'}
                        options={townsAux}
                        value={townAux || null}
                        onChange={(e) => handleSelectTownChange(e)}
                        required
                    />
                    <input
                        tabIndex={-1}
                        autoComplete="off"
                        style={{ opacity: 0, height: 0 }}
                        value={state.town || ''}
                        required
                        readOnly
                    />
                </Col>
            </Row>
            <Row>
                <Col xs={6}>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="fourth" className="my-2" onClick={(e) => disableEnableOperators(e)}>
                            {state?.active
                            ?
                            <><i className="fas fa-ban me-2"></i> {t('global.disable')}</>
                            :
                            <><i className="fas fa-check me-2"></i> {t('global.enable')}</>
                            }
                        </Button>
                    )}
                </Col>
                <Col xs={6} className="d-flex justify-content-end">
                    <Button variant='primary' type="submit" className="w-100 my-2 me-2">
                        {isRegistering ? (
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        ) : isAddingOrEditing === 'editing' ? (
                            <>{t('global.edit')}</>
                        ) : (
                            <>{t('global.register')}</>
                        )}
                    </Button>
                    {isAddingOrEditing === 'editing' && (
                        <Button variant="fourth" className="w-100 my-2 cursor" onClick={(e) => handleDeleteOperators(e, state?._id)}>
                            {t('global.delete')}
                        </Button>
                    )}
                </Col>
            </Row>
        </Form>
    );
}
